module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width add-on-block-outer",
    class: {
      'alternative': (_vm.current.price ? _vm.current.price : _vm.current.full_package_price) > _vm.package.price, 'full-experience': (_vm.current.price ? _vm.current.price : _vm.current.full_package_price) < _vm.package.price
    }
  }, [_c('div', {
    staticClass: "fields selection add-on-block",
    class: {
      checked: _vm.checkedC
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection.packages[0]),
      expression: "selection.packages[0]"
    }],
    attrs: {
      "type": "radio",
      "name": "packageSelection",
      "id": _vm.package.id
    },
    domProps: {
      "value": _vm.package.id,
      "checked": _vm.checkedC,
      "checked": _vm._q(_vm.selection.packages[0], _vm.package.id)
    },
    on: {
      "__c": function($event) {
        _vm.$set(_vm.selection.packages, 0, _vm.package.id)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.package.id
    }
  }, [_c('div', {
    staticClass: "full-width-field-block"
  }, [_c('div', {
    staticClass: "add-on-checkbox-container"
  }, [_c('div', {
    staticClass: "checkbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [(_vm.selection.hasOwnProperty('toSwapPackage') && _vm.selection.toSwapPackage == _vm.package.id) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.locale.text_current_selection) + ":")]), _vm._v(" " + _vm._s(_vm.package.name))]) : ((_vm.current.price ? _vm.current.price : _vm.current.full_package_price) == _vm.package.price) ? _c('span', [_vm._v(_vm._s(_vm.package.name))]) : ((_vm.current.price ? _vm.current.price : _vm.current.full_package_price) < _vm.package.price) ? _c('span', [_vm._v(" " + _vm._s(_vm.package.name))]) : _c('span', [_c('b', [_vm._v(_vm._s(_vm.locale.text_alternative_option) + ":")]), _vm._v(" " + _vm._s(_vm.package.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "content-block",
    domProps: {
      "innerHTML": _vm._s(_vm.package.full_description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-image",
    style: ({
      background: 'url(' + _vm.package.image_url + ') center center / contain no-repeat'
    })
  })]), _vm._v(" "), (_vm.checked && _vm.programme && (_vm.current.package_id !== _vm.selection.toSwapPackage)) ? _c('div', {
    staticClass: "add-on-checkbox-container-warning"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_vm._v("\n                    " + _vm._s(_vm.locale.text_automatic_selection_warning.replace(':package', _vm.baseProgramme)) + "\n                ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f085ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/PackageOptions/AddonSelection.vue
// module id = 151
// module chunks = 0